import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=097827bc&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=ts"
export * from "./ContactInfo.vue?vue&type=script&lang=ts"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=097827bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097827bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097827bc')) {
      api.createRecord('097827bc', component.options)
    } else {
      api.reload('097827bc', component.options)
    }
    module.hot.accept("./ContactInfo.vue?vue&type=template&id=097827bc&scoped=true", function () {
      api.rerender('097827bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactInfo.vue"
export default component.exports